module.exports = __webpack_public_path__ + "media/images/misused-sample-2-2f0d06c0323d79adf4a1889e2be2f57a.png";